import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ApprovedInsuranceProviderRow from "./ApprovedInsuranceProviderRow";
import useLang from "Shared/hooks/useLanguage";
import useIsMobile from "Shared/hooks/useIsMobile";
import { ArrowDown, ArrowUp } from "Shared/Icons";
import { Loader } from "Shared/Common/Loader";
import NoRecord from "Shared/Common/NoRecord";

function ApprovedInsuranceProviderGridData(props: {
  rows: any;
  loading: boolean;
  sort: any;
  searchRequest: any;
  onInputChangeSearch: any;
  handleKeyPress: (e: React.KeyboardEvent) => void;
  handleSort: (columnName: string) => void;
  searchRef: any;
  loadData: (loader: boolean, reset: boolean) => void;
}) {
  const {
    rows,
    loading,
    sort,
    searchRequest,
    onInputChangeSearch,
    handleKeyPress,
    handleSort,
    searchRef,
    loadData: _loadData,
  } = props;

  const { t } = useLang();
  const isMobile = useIsMobile();
  

  return (
    <div className="table_bordered overflow-hidden">
      <TableContainer
        sx={
          
          isMobile
          ? {}
          :
          
          {
          maxHeight: "calc(100vh - 100px)",
          "&::-webkit-scrollbar": {
            width: 7,
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#fff",
          },
          "&:hover": {
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "var(--kt-gray-400)",
              borderRadius: 2,
            },
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "var(--kt-gray-400)",
            borderRadius: 2,
          },
        }}
        className="shadow-none"
      >
        <Table
          aria-label="sticky table collapsible"
          className="table table-cutome-expend table-bordered table-sticky-header table-head-2-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
        >
          <TableHead>
            <TableRow className="h-40px">
              <TableCell>
                <input
                  id="ApprovedInsuranceProviderNameSearch"
                  type="text"
                  name="providerName"
                  className="form-control bg-white min-w-100px w-100 rounded-2 fs-8 h-30px"
                  placeholder={t("Search ...")}
                  value={searchRequest.providerName}
                  onChange={onInputChangeSearch}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
              </TableCell>
              <TableCell>
                <input
                  id="ApprovedInsuranceProviderCodeSearch"
                  type="text"
                  name="providerCode"
                  className="form-control bg-white min-w-100px w-100 rounded-2 fs-8 h-30px"
                  placeholder={t("Search ...")}
                  value={searchRequest.providerCode}
                  onChange={onInputChangeSearch}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
              </TableCell>
              <TableCell>
                <input
                  id="ApprovedInsuranceAddressSearch"
                  type="text"
                  name="address"
                  className="form-control bg-white min-w-100px w-100 rounded-2 fs-8 h-30px"
                  placeholder={t("Search ...")}
                  value={searchRequest.address}
                  onChange={onInputChangeSearch}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
              </TableCell>
              <TableCell>
                <input
                  id="ApprovedInsuranceCitySearch"
                  type="text"
                  name="city"
                  className="form-control bg-white min-w-100px w-100 rounded-2 fs-8 h-30px"
                  placeholder={t("Search ...")}
                  value={searchRequest.city}
                  onChange={onInputChangeSearch}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
              </TableCell>
              <TableCell>
                <input
                  id="ApprovedInsuranceStateSearch"
                  type="text"
                  name="state"
                  className="form-control bg-white min-w-100px w-100 rounded-2 fs-8 h-30px"
                  placeholder={t("Search ...")}
                  value={searchRequest.state}
                  onChange={onInputChangeSearch}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
              </TableCell>
              <TableCell>
                <input
                  id="ApprovedInsuranceZipCodeSearch"
                  type="text"
                  name="zipCode"
                  className="form-control bg-white min-w-100px w-100 rounded-2 fs-8 h-30px"
                  placeholder={t("Search ...")}
                  value={searchRequest.zipCode}
                  onChange={onInputChangeSearch}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
              </TableCell>
              <TableCell>
                <input
                  id="ApprovedInsurancePhoneNumberSearch"
                  type="text"
                  name="phoneNumber"
                  className="form-control bg-white min-w-100px w-100 rounded-2 fs-8 h-30px"
                  placeholder={t("Search ...")}
                  value={searchRequest.phoneNumber}
                  onChange={onInputChangeSearch}
                  onKeyDown={(e) => handleKeyPress(e)}
                />
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
            <TableRow className="h-30px">
              <TableCell>
                <div
                  onClick={() => handleSort("providerName")}
                  className="d-flex justify-content-between cursor-pointer"
                  ref={searchRef}
                >
                  <div>{t("Provider Name")}</div>
                  <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                    <ArrowUp
                      CustomeClass={`${
                        sort.sortingOrder === "desc" &&
                        sort.clickedIconData === "providerName"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0 "`}
                    />
                    <ArrowDown
                      CustomeClass={`${
                        sort.sortingOrder === "asc" &&
                        sort.clickedIconData === "providerName"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0`}
                    />
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div
                  onClick={() => handleSort("providerCode")}
                  className="d-flex justify-content-between cursor-pointer"
                  ref={searchRef}
                >
                  <div>{t("Provider Code")}</div>
                  <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                    <ArrowUp
                      CustomeClass={`${
                        sort.sortingOrder === "desc" &&
                        sort.clickedIconData === "providerCode"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0 "`}
                    />
                    <ArrowDown
                      CustomeClass={`${
                        sort.sortingOrder === "asc" &&
                        sort.clickedIconData === "providerCode"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0`}
                    />
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div
                  onClick={() => handleSort("address")}
                  className="d-flex justify-content-between cursor-pointer"
                  ref={searchRef}
                >
                  <div>{t("Address")}</div>
                  <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                    <ArrowUp
                      CustomeClass={`${
                        sort.sortingOrder === "desc" &&
                        sort.clickedIconData === "address"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0 "`}
                    />
                    <ArrowDown
                      CustomeClass={`${
                        sort.sortingOrder === "asc" &&
                        sort.clickedIconData === "address"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0`}
                    />
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div
                  onClick={() => handleSort("city")}
                  className="d-flex justify-content-between cursor-pointer"
                  ref={searchRef}
                >
                  <div>{t("City")}</div>
                  <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                    <ArrowUp
                      CustomeClass={`${
                        sort.sortingOrder === "desc" &&
                        sort.clickedIconData === "city"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0 "`}
                    />
                    <ArrowDown
                      CustomeClass={`${
                        sort.sortingOrder === "asc" &&
                        sort.clickedIconData === "city"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0`}
                    />
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div
                  onClick={() => handleSort("state")}
                  className="d-flex justify-content-between cursor-pointer"
                  ref={searchRef}
                >
                  <div>{t("State")}</div>
                  <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                    <ArrowUp
                      CustomeClass={`${
                        sort.sortingOrder === "desc" &&
                        sort.clickedIconData === "state"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0 "`}
                    />
                    <ArrowDown
                      CustomeClass={`${
                        sort.sortingOrder === "asc" &&
                        sort.clickedIconData === "state"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0`}
                    />
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div
                  onClick={() => handleSort("zipCode")}
                  className="d-flex justify-content-between cursor-pointer"
                  ref={searchRef}
                >
                  <div>{t("Zip Code")}</div>
                  <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                    <ArrowUp
                      CustomeClass={`${
                        sort.sortingOrder === "desc" &&
                        sort.clickedIconData === "zipCode"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0 "`}
                    />
                    <ArrowDown
                      CustomeClass={`${
                        sort.sortingOrder === "asc" &&
                        sort.clickedIconData === "zipCode"
                          ? "text-success fs-7"
                          : "text-gray-700 fs-7"
                      }  p-0 m-0`}
                    />
                  </div>
                </div>
              </TableCell>
              <TableCell>{t("Phone Number")}</TableCell>
              <TableCell>{t("Status")}</TableCell>
              <TableCell>{t("Approved By")}</TableCell>
              <TableCell>{t("Date & Time")}</TableCell>
              <TableCell>{t("File")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableCell colSpan={11} className="">
                <Loader />
              </TableCell>
            ) : rows?.length ? (
              rows?.map((row: any) => (
                <ApprovedInsuranceProviderRow key={row.id} row={row} />
              ))
            ) : (
              <NoRecord colSpan={11} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default ApprovedInsuranceProviderGridData;
